module.exports = __webpack_public_path__ + "static/media/loader.41c7aa85.gif";